import React, { FC, useMemo } from 'react';
import PaperCard from 'src/components/PaperCard';
import StatTitle from 'src/components/StatTitle';
import { ShortcutsProps } from './types';
import {
  List,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  alpha,
  listItemAvatarClasses,
  useTheme,
} from '@mui/material';
import { ArrowBackIosNew } from '@mui/icons-material';
import { transition } from 'src/theme';
import { Dispatch } from 'redux';
import { Routes } from 'src/routes';
import { routingOnRouteRequest } from 'src/app/store/routingSlice';
import { connect } from 'react-redux';
import ShortcutsList from './List';

const RowArrowIcon = (
  <ArrowBackIosNew sx={{ fontSize: ({ spacing }) => spacing(1.625) }} />
);
const DEFAULT_TITLE = 'קיצורי דרך';

const Shortcuts: FC<ShortcutsProps> = ({
  shortcuts,
  title = DEFAULT_TITLE,
  secondaryTitle = '',
}) => {
  const { spacing } = useTheme();

  const { width, height } = useMemo(
    () => ({ width: spacing(41.5), height: spacing(45) }),
    [spacing],
  );
  return (
    <PaperCard sx={{ height, width, alignSelf: 'flex-end' }}>
      <StatTitle statName={title} secondary={secondaryTitle} />
      <ShortcutsList shortcuts={shortcuts} />
    </PaperCard>
  );
};

export default Shortcuts;
